import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faStore,
  faCommentDots,
  faExternalLinkAlt,
} from "@fortawesome/free-solid-svg-icons"
import * as styles from "../../styles/officialgoods.module.scss"

const OfficialGoodsCards = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <span className={styles.subTitle}>SUPPORT & GOODS</span>
        <div className={styles.mainTitle}>オリジナルアイテム販売中！</div>
        <p className={styles.leadText}>
          普段使いもできるバイカー向けグッズや、ツーリングで使えるLINEスタンプを作っています。活動を応援いただけると嬉しいです！
        </p>
      </div>

      <div className={styles.grid}>
        <a
          href="https://suzuri.jp/..."
          target="_blank"
          rel="noopener noreferrer"
          className={styles.card}
        >
          <div className={`${styles.iconCircle} ${styles.suzuri}`}>
            <FontAwesomeIcon icon={faStore} />
          </div>
          <div className={styles.cardBody}>
            <div className={styles.cardTitle}>SUZURIショップ</div>
            <div className={styles.cardDesc}>Tシャツ・ステッカーなど</div>
          </div>
          <FontAwesomeIcon
            icon={faExternalLinkAlt}
            className={styles.extIcon}
          />
        </a>

        <a
          href="https://line.me/S/sticker/..."
          target="_blank"
          rel="noopener noreferrer"
          className={styles.card}
        >
          <div className={`${styles.iconCircle} ${styles.line}`}>
            <FontAwesomeIcon icon={faCommentDots} />
          </div>
          <div className={styles.cardBody}>
            <div className={styles.cardTitle}>LINEスタンプ</div>
            <div className={styles.cardDesc}>ツーリングの連絡に便利</div>
          </div>
          <FontAwesomeIcon
            icon={faExternalLinkAlt}
            className={styles.extIcon}
          />
        </a>
      </div>
    </div>
  )
}

export default OfficialGoodsCards
